import React from 'react'
// import Titel from '../component/Titel'
export default function About() {
  return (
    <div>
      {/* <Titel titel={"this is a titel form about page"} dis={"content about"}/> */}
      <h1>hello from about</h1>
    </div>
  )
}
